import React from "react";
import s from "./index.css";
import withStyles from "isomorphic-style-loader/lib/withStyles";
import html2canvas from "html2canvas";
import { convertCanvasToImage, saveFile } from "../../../utils";

import Button from "../components/Button";

function formatThousands(event) {
  if (event.target.innerText) {
    event.target.innerText = event.target.innerText
      .replace(/(\d),(\d)/g, "$1$2")
      .replace(/(\d)(?=(\d{3}\D?)+(\D|$))/g, "$1,");
  }
}

class P44 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dataset: [],
      tableColumns: [],
      tableList: [],
    };
  }
  // 截图并下载
  captureAndDownload = () => {
    // 通过class选择器获取所有要截图的div
    const divs = document.querySelectorAll(".PageBox");
    const w = divs.offsetWidth;
    const h = divs.offsetHeight;

    Array.from(divs).forEach((div, index) => {
      html2canvas(div, {
        useCORS: true,
        scale: 2, // 将画布的尺寸放大到原始尺寸的两倍
        logging: false,
        foreignObjectRendering: true,
      }).then((canvas) => {
        const src = convertCanvasToImage(canvas).src;
        saveFile(src, `热梗内容`);

        // link.click();
      });
    });
  };

  render() {
    return (
      <div className={s.appBox}>
        <Button
          type="primary"
          onClick={this.captureAndDownload}
          style={{ margin: "10px 10px ", display: "inline" }}
        >
          下载
        </Button>

        <div
          className="PageBox"
          style={{
            width: "680px",
            height: "965px",
          }}
        >
          <div className={s.InnerBox}>
            <div className={s.InnerBox_title}>
              <div contentEditable>01</div>
              <div contentEditable>社交塑料瓶</div>
            </div>
            <div className={s.InnerBox_content} contentEditable>指没有主动社交的能力和勇气，交朋友的唯一方式就是把自己放在角落里然后等好心人捡走。 </div>
            <div className={s.InnerBox_content2} contentEditable>真的破防了，这里有个「社交塑料瓶」求捡走。 </div>
          </div>
        </div>
      </div>
    );
  }
}
export default withStyles(s)(P44);



// WEBPACK FOOTER //
// src/routes/visualChart/P44/index.js